import { CustomBlock, BlockMutator } from '@ng-blockly/blockly';
declare var Blockly: any;

/**
 * 自定义下拉块，可以传入参数作为extensions,来设置其field。
 */
export class ValuesDropDownBlock extends CustomBlock {
  jsonBlock = {};
  constructor(type: string, block: any, blockMutator: BlockMutator, ...args: any[]) {
    super(type, block, blockMutator, ...args);
    this.jsonBlock = {
      type: this.type,
      message0: '%1',
      args0: [
        {
          type: 'input_dummy',
          name: 'INPUT'
        }],
      inputsInline: false,
      output: args[1],
      // colour: args[2] || 230,
      style: 'text_blocks',
      tooltip: '',
      helpUrl: '',
      extensions: [args[0]]
    };
    this.class = ValuesDropDownBlock;
  }

  defineBlock() {
    this.block.jsonInit(this.jsonBlock);
  }

  toXML() {
    return `<block type='${this.type}'></block>`;
  }

  toJavaScriptCode(e: any) {
    return [e.getFieldValue('NAME'), Blockly.JavaScript.ORDER_ATOMIC];
  }

}
